<div class="heat-selection-container">
  <label class="title">{{ 'module.shared.buildingEfficiencyWizard.step3.titleText' | translate }}</label
  ><br />
  <label class="period">
    {{ 'module.shared.buildingEfficiencyWizard.step3.periodText' | translate }}
    {{ displayStartDate }} - {{ displayEndDate }}
  </label>
  <div class="question-part-container">
    <div class="info-text-container">
      <div class="info-text">
        <span class="text">{{ 'module.shared.buildingEfficiencyWizard.step3.labelText' | translate }}</span>
        <span *ngIf="getToggleVisibility()" class="toggle-text">{{ 'module.shared.buildingEfficiencyWizard.step3.toggleText' | translate }}</span>
      </div>
    </div>
    <div *ngIf="getToggleVisibility()" class="toggle-container">
      <span class="toggle">
        <span class="fa fa-info-circle" matTooltip="{{ note }}" matTooltipPosition="above" matTooltipClass="matTooltip-heat-selection-component"> </span>
        <mat-slide-toggle [(ngModel)]="toggled" (change)="onToggleChange($event.checked)" class="edit-toggle"> </mat-slide-toggle>
      </span>
    </div>
  </div>

  <div class="form-container">
    <div class="heat-meter-section" *ngFor="let item of heatSelectionTasks; index as i">
      <div class="heat-checkbox">
        <span class="heat-meter-section-list-section">
          <mat-checkbox [checked]="item.allComplete" [indeterminate]="someComplete(i)" (change)="setAll(i, $event.checked)">
            {{ item.displayName }}
          </mat-checkbox>
        </span>
      </div>
      <div>
        <span class="heat-meter-section-list-section">
          <ul>
            <li *ngFor="let subtask of item.subtasks; index as s">
              <div
                class="sub-checkbox-container"
                *ngIf="(subtask.hasMeterConsumption === false && subtask.completed === true) || (subtask.meterNumber && subtask.meterNumber !== '')"
              >
                <div
                  [ngClass]="{
                    'sub-checkbox': true,
                    hidden: !subtask.meterNumber || subtask.meterNumber === ''
                  }"
                >
                  <mat-checkbox class="meter-checkbox" [(ngModel)]="subtask.completed" (ngModelChange)="updateAllComplete(i)">
                    {{ subtask.name }}
                  </mat-checkbox>
                </div>

                <div class="sub-labels" *ngIf="subtask.meterNumber && subtask.meterNumber !== ''">
                  <div>{{ 'module.shared.buildingEfficiencyWizard.step3.nummer' | translate }}</div>
                  <div>{{ subtask.meterNumber | noLeadingZero }}</div>
                </div>

                <div>
                  <mat-form-field class="consumption">
                    <input
                      title="consumption"
                      [(ngModel)]="subtask.value"
                      (change)="updateValue(i, s, $event.target.value)"
                      (input)="updateValue(i, s, $event.target.value)"
                      matInput
                      type="text"
                      (focus)="focus(i, s, $event.target.value)"
                      (blur)="blur(i, s, $event.target.value)"
                      (keypress)="numberOnly($event)"
                      maxlength="7"
                    />
                  </mat-form-field>
                  <span matSuffix>{{ item.consumptionLabel }}</span>
                  <span
                    *ngIf="subtask.tooltipMessage !== null && toggled === true"
                    class="fa fa-info-circle sub-tooltip"
                    [matTooltip]="subtask.tooltipMessage"
                    matTooltipPosition="above"
                  ></span>
                </div>
              </div>
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
  <div class="summation">
    <label class="text">{{ 'module.shared.buildingEfficiencyWizard.step3.sumText' | translate }}</label>
    <label class="value">{{ sum | localNumber }} kWh</label>
  </div>
  <div class="footer">
    <label>{{ 'module.shared.buildingEfficiencyWizard.footerText' | translate }}</label>
  </div>
</div>
